import {
    Component,
    EventEmitter,
    TemplateRef,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'pm-donut-chart',
    //templateUrl: './app/controls/components/chart/donut-chart.html'
    templateUrl: './donut-chart.html',
})
export class DonutChartComponent {

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/donut-chart/donut-chart-component.ts